module.exports = __webpack_public_path__ + "static/media/Fast Fast App Cover.18a11b9b.png";